import { createContext } from 'react';

import { type Project, type GetMyProjectsQuery, type GetReportForSelectedDateQuery } from '@/graphql/generated/graphql';

interface InstitutionPageContextValueType {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpdate: (value: any, key: string) => void;
  selectedProject: Project | undefined;
  projects: GetMyProjectsQuery['getMyProjects'] | undefined;
  selectedReport: GetReportForSelectedDateQuery['getReportForSubmission'] | undefined;
  isWeekendsEnabled: boolean;
  projectShifts: string;
  projectHolidays: string;
}

// ============================================================
// ================ END  INTERFACES & TYPES =================
// ============================================================
// const date = dayjs(new Date()).format("DD/MM/YYYY");
export const ReportContext = createContext<InstitutionPageContextValueType>({
  onUpdate: () => {},
  selectedProject: undefined,
  projects: undefined,
  selectedReport: undefined,
  isWeekendsEnabled: false,
  projectShifts: '',
  projectHolidays: '',
});
